import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Greetings } from '../components/HomeHeader';

export type GreetingsState = {
  greetings?: Greetings;
};

const initialState: GreetingsState = {
  greetings: undefined
};

const greetingsSlice = createSlice({
  name: 'greetings',
  initialState,
  reducers: {
    setGreetings: (state, action: PayloadAction<Greetings | undefined>) => {
      state.greetings = action.payload;
    }
  }
});

export const { setGreetings } = greetingsSlice.actions;
export default greetingsSlice.reducer;
